import Component from '../core/Component'
import Typewriter from 'typewriter-effect/dist/core';

export default class TypewriterOfflineVal extends Component {

   constructor(element) {
      super(element);

      this.replacement = this.element.querySelector("#replacement")
      this.replacementText = this.replacement.innerHTML
      this.replacement
      this.sentence
      this.element
   }

   prepare() {
      document.fonts.load('1rem "Muli"').then(() => {
         this.placeholderHeight = this.element.offsetHeight
         this.keepHeight(this.placeholderHeight)
         this.replacement.innerHTML = ""
         this.sentence = this.element.innerHTML

         const typewriter = new Typewriter(this.element, {
            autoStart: true,
            delay: 25,
            cursor: "",
            cursorClassName: "typewriter-cursor"
         });

         typewriter.pauseFor(200)
            .typeString(this.sentence)
            .pauseFor(400)
            .callFunction(this.strikeText)
            .callFunction(this.removeTypewriterCursor)
            .pauseFor(600)
            .callFunction((tp) => {
               this.addAnotherTypewriter(this.replacementText)
            })
            .start()

      })

   }

   strikeText() {
      document.querySelector("#toBeStriked").classList.add("striked")
   }

   addAnotherTypewriter(replacementText) {
      const typewriterSecond = new Typewriter(this.element.querySelector("#replacement"), {
         autoStart: true,
         delay: 50,
         cursor: "",
         cursorClassName: "typewriter-cursor"
      });

      typewriterSecond.typeString(replacementText)
         .start()
   }

   removeTypewriterCursor() {
      setTimeout(() => {
         document.querySelector(".typewriter-cursor").remove()
      }, 300);
   }

   keepHeight(height) {
      this.element.style.height = height + "px";
   }
}